export const RANGE_OPTIONS = ['HOUR', 'DAY', 'WEEK', 'MONTH'] as const;
